import type * as Types from '../../../schemas/shopify/admin.types';

import { PickPageCollectionNodeFragmentDoc } from '../fragments/pickPageCollection.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcherGemX } from '../../utils/gatewayClientGemX';
export type PickPageCollectionsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortKey?: Types.InputMaybe<Types.CollectionSortKeys>;
  reverse?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type PickPageCollectionsQueryResponse = {
  collections: {
    edges: Array<
      Pick<Types.CollectionEdge, 'cursor'> & {
        node: Pick<Types.Collection, 'id' | 'handle' | 'title' | 'templateSuffix'> & {
          image?: Types.Maybe<Pick<Types.Image, 'url'>>;
          resourcePublications: {
            nodes: Array<{ publication: { app: Pick<Types.App, 'handle'> } }>;
          };
        };
      }
    >;
    pageInfo: Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>;
  };
};

export const PickPageCollectionsDocument = `
    query PickPageCollections($first: Int!, $after: String, $query: String, $sortKey: CollectionSortKeys, $reverse: Boolean) {
  collections(
    first: $first
    after: $after
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    edges {
      cursor
      node {
        ...PickPageCollectionNode
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PickPageCollectionNodeFragmentDoc}`;

export const usePickPageCollectionsQuery = <
  TData = PickPageCollectionsQueryResponse,
  TError = unknown,
>(
  variables: PickPageCollectionsQueryVariables,
  options?: UseQueryOptions<PickPageCollectionsQueryResponse, TError, TData>,
) => {
  return useQuery<PickPageCollectionsQueryResponse, TError, TData>(
    ['PickPageCollections', variables],
    appFetcherGemX<PickPageCollectionsQueryResponse, PickPageCollectionsQueryVariables>(
      PickPageCollectionsDocument,
      variables,
    ),
    options,
  );
};

usePickPageCollectionsQuery.getKey = (variables: PickPageCollectionsQueryVariables) => [
  'PickPageCollections',
  variables,
];
